import {
  FulfilmentDetail,
  FulfilmentType,
} from '../../../../../../models/fulfilment'
import { useAppSelector } from '../../../../../../state/hooks'
import { selectIsSaleCustomerContactInfoReviewed } from '../../../../../../state/slices/uiStateSlice'
import {
  CurrentView,
  ShouldFulfillOpt,
  useLineItemFulfillmentContext,
} from '../LineItemFulfillmentContext'
import { isMissingContactInfo } from '../LineItemFulfillmentUtils'

interface UseLineItemFulfillmentDecisionFlowProps {
  onFulfilmentDetailsSet: (fulfilmentDetails: FulfilmentDetail) => void
  onClose: () => void
}

export const useLineItemFulfillmentDecisionFlow = ({
  onFulfilmentDetailsSet,
  onClose,
}: UseLineItemFulfillmentDecisionFlowProps) => {
  const {
    setCurrentView,
    currentDecision,
    currentCustomer,
  } = useLineItemFulfillmentContext()

  const isContactInfoReviewed = useAppSelector(
    selectIsSaleCustomerContactInfoReviewed
  )

  const handleContinueFromDecisionView = () => {
    if (currentDecision === ShouldFulfillOpt.YES) {
      if (currentCustomer) {
        if (isMissingContactInfo(currentCustomer) || !isContactInfoReviewed) {
          setCurrentView(CurrentView.REVIEW_CONTACT_INFO)
        } else {
          setCurrentView(CurrentView.FULFILMENT_METHOD)
        }
      } else {
        setCurrentView(CurrentView.ADD_CUSTOMER)
      }
    } else {
      onFulfilmentDetailsSet({
        type: FulfilmentType.UNSPECIFIED,
        note: '',
      })
      onClose()
    }
  }

  return {
    handleContinueFromDecisionView,
  }
}
